import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PendingInvite {
  email: string;
  role: 'admin' | 'member';
}

interface BrandingData {
  primaryColor: string;
  industry: string;
  description: string;
}

interface OnboardingState {
  currentStep: number;
  currentSubStep: number;
  workspaceId: string | null;
  decisionType: string | null;
  decisionSubtype: string | null;
  trigger: string;
  stakes: string;
  previousAttempts: string;
  impactScore: number;
  urgencyScore: number;
  quickMode: boolean;
  pendingInvites: PendingInvite[];
  brandingData: BrandingData | null;
  
  setStep: (step: number) => void;
  setSubStep: (subStep: number) => void;
  setWorkspace: (id: string) => void;
  setDecisionArea: (type: string) => void;
  setDecisionSubtype: (subtype: string) => void;
  setTrigger: (trigger: string) => void;
  setStakes: (stakes: string) => void;
  setPreviousAttempts: (attempts: string) => void;
  setSituation: (trigger: string, stakes: string, previousAttempts: string) => void;
  setScores: (impact: number, urgency: number) => void;
  setQuickMode: (enabled: boolean) => void;
  setPendingInvites: (invites: PendingInvite[]) => void;
  setBrandingData: (data: BrandingData) => void;
  reset: () => void;
}

export type { PendingInvite, BrandingData };

const initialState = {
  currentStep: 1,
  currentSubStep: 0,
  workspaceId: null,
  decisionType: null,
  decisionSubtype: null,
  trigger: '',
  stakes: '',
  previousAttempts: '',
  impactScore: 0,
  urgencyScore: 0,
  quickMode: false,
  pendingInvites: [] as PendingInvite[],
  brandingData: null as BrandingData | null,
};

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      ...initialState,
      
      setStep: (step) => set({ currentStep: step, currentSubStep: 0 }),
      setSubStep: (subStep) => set({ currentSubStep: subStep }),
      setWorkspace: (id) => set({ workspaceId: id }),
      setDecisionArea: (type) => set({ decisionType: type }),
      setDecisionSubtype: (subtype) => set({ decisionSubtype: subtype }),
      setTrigger: (trigger) => set({ trigger }),
      setStakes: (stakes) => set({ stakes }),
      setPreviousAttempts: (attempts) => set({ previousAttempts: attempts }),
      setSituation: (trigger, stakes, previousAttempts) => 
        set({ trigger, stakes, previousAttempts }),
      setScores: (impact, urgency) => set({ impactScore: impact, urgencyScore: urgency }),
      setQuickMode: (enabled) => set({ quickMode: enabled }),
      setPendingInvites: (invites) => set({ pendingInvites: invites }),
      setBrandingData: (data) => set({ brandingData: data }),
      reset: () => set(initialState),
    }),
    {
      name: 'quentari-onboarding',
      version: 4,
    }
  )
);
